import * as React from "react";
function SvgChevronDown(
  props: React.SVGProps<SVGSVGElement>,
  svgRef?: React.Ref<SVGSVGElement>
) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 32 32"
      ref={svgRef}
      {...props}
    >
      <path
        fill="none"
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth={4}
        d="M2 9l14 14L30 9"
      />
    </svg>
  );
}
const ForwardRef = React.forwardRef(SvgChevronDown);
const MemoForwardRef = React.memo(ForwardRef);
export default MemoForwardRef;
